<template>
  <div>
    <div class="appearance_header">Appearance</div>
    <BotSettingsForm
      v-if="chosenWidget"
      form-type="update"
      :data="{ ...chosenWidget?.settings }"
    />
    <ButtonWithLoadWebsite
      :disabled="canNotUpdate"
      @onClick="updateWidget"
      class="appearance_btn"
      title="Save changes"
    />
  </div>
</template>

<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";
import BotSettingsForm from "../BotSettings/BotSettingsForm.vue";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  data() {
    return {};
  },
  components: {
    BotSettingsForm,
    ButtonWithLoadWebsite,
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    updateData() {
      return store?.state?.createBotData?.updateData;
    },
    chosenWidget() {
      return store?.state?.users?.chosenWidget;
    },
    canNotUpdate() {
      const { name, welcomeMessage, botIcon } = this.updateData;
      return (
        !name ||
        !welcomeMessage ||
        !botIcon ||
        JSON.stringify(this.chosenWidget?.settings) ===
          JSON.stringify(this.updateData)
      );
    },
  },
  methods: {
    async updateWidget() {
      const updateData = this.updateData;

      const formData = new FormData();

      Object.keys(updateData).forEach((key) => {
        const value = updateData[key];

        // console.log(key)

        if (
          (!key.includes("Icon") && value === "") ||
          (!key.includes("Icon") && value === null)
        ) {
          return;
        }

        if (key === "website") {
          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else {
          formData.append(key, value);
        }
      });

      try {
        store.dispatch("startLoading");

        const { data } = await DataService.patch(
          `${API_ENDPOINT}widget/update-widget/${this.chosenWidget?.id}`,
          formData,
          { "Content-Type": "multipart/form-data" }
        );

        if (data) {
          store.dispatch("setChosen", data);
          store.dispatch("updateWidgets", {
            id: data?.id,
            name: data?.settings?.name,
          });
          this.$toast.success("Widget successfully updated");
          this.$router.replace("/user/dashboard");
        }
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Widget update error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },
  },
  mounted() {
    store.dispatch("updateDataChange", this.chosenWidget?.settings);
  },
};
</script>

<style scoped>
.appearance_header {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.appearance_btn {
  display: block;
  margin: 0 auto;
  margin-top: 32px;
  padding: 11px 27px;
}
</style>
